// Hindi of src/content/legal/privacy.ts. Keep keys and structure in step with the English.
import { COMPANY, GRIEVANCE_OFFICER } from '../company';
import type { LegalDoc } from './types';

export const PRIVACY_HI: LegalDoc = {
  title: 'निजता नीति',
  summary:
    'हम सिर्फ़ वही जानकारी लेते हैं जो आपके बच्चे की रिपोर्ट तैयार करने के लिए ज़रूरी है। हम इसे कभी बेचते नहीं, न ही विज्ञापन के लिए इस्तेमाल करते हैं, और आप इसे कभी भी देख, सुधार या हटा सकते हैं।',
  updated: '28 September 2026',
  sections: [
    {
      id: 'about-us',
      heading: 'हमारे बारे में',
      blocks: [
        'यह हिंदी अनुवाद आपकी सुविधा के लिए है। किसी भी अंतर की स्थिति में अंग्रेज़ी संस्करण मान्य होगा।',
        `Nurture, **${COMPANY.legalName}** (“ZenQuip”, “हम”, “हमें”) का एक प्रोडक्ट है, जो ZenQuip की मानसिक स्वास्थ्य सेवाओं के परिवार का हिस्सा है।`,
        [
          `पंजीकृत कार्यालय: ${COMPANY.address}`,
          `CIN: ${COMPANY.cin}`,
          `ईमेल: [${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail}) · शिकायतें: [${GRIEVANCE_OFFICER.email}](mailto:${GRIEVANCE_OFFICER.email}) · फ़ोन: ${GRIEVANCE_OFFICER.phone}`,
        ],
        'भारत के Digital Personal Data Protection Act, 2023 (डिजिटल व्यक्तिगत डेटा संरक्षण अधिनियम, 2023; “DPDP Act”) के तहत, यहाँ बताए गए व्यक्तिगत डेटा के लिए हम डेटा फ़िड्यूशियरी (Data Fiduciary) हैं।',
      ],
    },
    {
      id: 'scope',
      heading: 'दायरा',
      blocks: [
        'यह नीति Nurture वेब ऐप, उसकी रिपोर्टों और घरेलू प्रोग्रामों, और उनके बारे में हमारे द्वारा आपको भेजे जाने वाले संदेशों पर लागू होती है। ZenQuip की दूसरी सेवाओं की अपनी नीतियाँ zenquip.com पर हैं।',
        'Nurture माता-पिता और क़ानूनी अभिभावकों के लिए है। अकाउंट धारक हमेशा एक वयस्क होता है; हम बच्चों को अकाउंट नहीं देते।',
      ],
    },
    {
      id: 'what-we-collect',
      heading: 'हम क्या जानकारी लेते हैं',
      blocks: [
        '**आपके बारे में:** आपका नाम, मोबाइल नंबर और/या ईमेल पता, देश, भाषा, और अगर आप पासवर्ड बनाते हैं तो वह पासवर्ड (जो सिर्फ़ वन-वे हैश के रूप में रखा जाता है)। इनवॉइस के लिए, चेकआउट पर आपका दिया बिलिंग नाम, फ़ोन नंबर और पता, और भारतीय इनवॉइस के लिए आपका राज्य।',
        '**आपके बच्चे के बारे में:** पहला नाम, उम्र, जेंडर, और “मेरे बच्चे के बारे में” में आप जो कुछ भी जोड़ना चुनें (जैसे कोई निदान, थेरेपी, स्कूल, भाषाएँ, उन्हें क्या पसंद है और किस बात से वे परेशान होते हैं)।',
        '**घरेलू आकलन में आप हमें जो बताते हैं:** आपके जवाब, नोट्स, आपकी चुनी हुई ख़ूबियाँ, और अगर आप दर्ज करें तो पहले हुए प्रोफ़ेशनल आकलनों के नतीजे।',
        '**घर पर आप जो दर्ज करते हैं:** घरेलू प्रोग्राम की गतिविधियों का रिकॉर्ड, लक्ष्य, आपके दर्ज किए “पल” (moments), और रिमाइंडर की सेटिंग्स।',
        '**जिन लोगों को आप जोड़ते हैं:** आपके बच्चे की केयर टीम, आपके बुलाए गए परिवार के सदस्यों, और एक नॉमिनी (देखें “आपके अधिकार”) के नाम और संपर्क विवरण। इन्हें सिर्फ़ तभी जोड़ें जब उन्हें इसकी उम्मीद हो।',
        '**भुगतान:** ऑर्डर और इनवॉइस के रिकॉर्ड, और हमारा पेमेंट प्रोवाइडर हमें जो रेफ़रेंस देता है। हम कार्ड, UPI या बैंक का विवरण कभी न देखते हैं, न रखते हैं।',
        '**तकनीकी:** आपको साइन इन रखने और सेवा को सुरक्षित रखने के लिए ज़रूरी डिवाइस और ब्राउज़र का विवरण, और सुरक्षा लॉग।',
        '**आपने हमें कैसे पाया:** अगर आप किसी विज्ञापन, कैंपेन लिंक या इनवाइट कोड से आए हैं, तो कौन-सा (स्रोत, कैंपेन और कोड)। साइन अप करने पर यह आपके अकाउंट के साथ सेव हो जाता है।',
        '**विज़िट:** कौन-से पेज देखे गए और कितनी देर तक। कुकीज़ के बिना हर विज़िटर को दिन में एक बार गिनने के लिए, हम आपके IP पते और ब्राउज़र के प्रकार को एक वन-वे कोड में बदलते हैं जो हर दिन बदल जाता है; IP पता ख़ुद नहीं रखा जाता और ये कोड 3 दिन के भीतर हटा दिए जाते हैं। अगर आप साइन इन हैं, तो विज़िट को इसी तरह आपके अकाउंट के साथ गिना जाता है। दूसरे एनालिटिक्स टूल सिर्फ़ तभी चलते हैं जब आप उनकी अनुमति दें (देखें “कुकीज़”)।',
        'हम आपके बच्चे की फ़ोटो, उपनाम, स्कूल का नाम या आधार नहीं माँगते, और आपसे अनुरोध है कि इन्हें खुले टेक्स्ट वाले बॉक्स में न लिखें।',
      ],
    },
    {
      id: 'how-we-use',
      heading: 'हम इसका इस्तेमाल कैसे करते हैं',
      blocks: [
        [
          'आपकी माँगी गई रिपोर्ट और घरेलू प्रोग्राम तैयार करने, देने और सुरक्षित रखने के लिए;',
          'आपको साइन-इन कोड, रसीदें, रिपोर्ट की डिलीवरी और, अगर आप इन्हें चालू करें तो, रोज़ के रिमाइंडर भेजने के लिए;',
          'इनवॉइस जारी करने और अपने टैक्स और क़ानूनी दायित्व पूरे करने के लिए;',
          'सेवा को सुरक्षित रखने, दुरुपयोग रोकने और समस्याएँ ठीक करने के लिए;',
          'आपके संपर्क करने पर आपको जवाब देने के लिए;',
          'कुल आँकड़ों में यह समझने के लिए कि कौन-से पेज और कैंपेन माता-पिता के काम आते हैं;',
          'ऐसी जानकारी से अपने सवाल और कंटेंट बेहतर बनाने के लिए, जिससे अब आपकी या आपके बच्चे की पहचान नहीं होती।',
        ],
        'आपकी रिपोर्ट और योजना तय नियमों और क्लिनिशियन के साथ मिलकर लिखे गए कंटेंट से तैयार होती है, किसी AI मॉडल से नहीं। हम आपके या आपके बच्चे के डेटा का इस्तेमाल AI मॉडल को ट्रेन करने के लिए नहीं करते।',
      ],
    },
    {
      id: 'consent',
      heading: 'सहमति और आपके बच्चे का डेटा',
      blocks: [
        'हम आपके बच्चे का डेटा उस सहमति के आधार पर प्रोसेस करते हैं जो आप, उनके माता-पिता या क़ानूनी अभिभावक के रूप में, अपना अकाउंट बनाते समय देते हैं। आप यह सहमति कभी भी वापस ले सकते हैं; इसे वापस लेना उतना ही आसान है जितना देना, और इससे पहले किए गए काम पर कोई असर नहीं पड़ता।',
        'हम विज्ञापन के लिए बच्चों के व्यवहार को ट्रैक या मॉनिटर नहीं करते, Nurture में कोई विज्ञापन नहीं दिखाते, और बच्चों के डेटा को किसी भी ऐसे तरीक़े से प्रोसेस नहीं करते जिससे उनकी भलाई को नुक़सान पहुँचने की संभावना हो।',
        'वैकल्पिक चीज़ों, ईमेल या WhatsApp पर सुझाव, रोज़ के रिमाइंडर, के लिए अलग से आपकी “हाँ” ज़रूरी है, और आप इन्हें सेटिंग्स में बंद कर सकते हैं। आपकी सहमति का इतिहास सेटिंग्स → निजता में है।',
      ],
    },
    {
      id: 'sharing',
      heading: 'हम इसे किसके साथ साझा करते हैं',
      blocks: [
        'सिर्फ़ उन सर्विस प्रोवाइडर्स के साथ जो ऊपर बताए गए उद्देश्यों के लिए, अनुबंध के तहत, हमारे लिए डेटा प्रोसेस करते हैं:',
        [
          'Amazon Web Services (होस्टिंग, स्टोरेज और ईमेल), मुंबई रीजन, भारत में;',
          'Razorpay (भुगतान, भारतीय ग्राहकों के लिए);',
          'Meta का WhatsApp Business प्लेटफ़ॉर्म (साइन-इन कोड, रिपोर्ट भेजना और आपके माँगे गए रिमाइंडर);',
          'Google (Google Analytics) और PostHog (प्रोडक्ट एनालिटिक्स, EU सर्वर), हमारे सार्वजनिक पेजों पर और सिर्फ़ तभी जब आप इनकी अनुमति दें; देखें “कुकीज़”।',
        ],
        'हम कोई रिपोर्ट किसी और के साथ सिर्फ़ तभी साझा करते हैं जब आप ख़ुद ऐसा करें: उसे डाउनलोड करके, WhatsApp पर भेजकर, या ऐप में रिपोर्ट लिंक या परिवार का इनवाइट बनाकर। रिपोर्ट लिंक आपकी चुनी हुई तारीख़ पर काम करना बंद कर देते हैं, और आप उन्हें उससे पहले भी बंद कर सकते हैं।',
        'जब क़ानून के तहत ज़रूरी हो, या किसी की जान या सुरक्षा की रक्षा के लिए, हम जानकारी प्रकट कर सकते हैं।',
      ],
    },
    {
      id: 'no-selling',
      heading: 'हम आपका डेटा कभी नहीं बेचते',
      blocks: ['हम व्यक्तिगत डेटा न बेचते हैं, न किराए पर देते हैं, न उसका लेन-देन करते हैं, और न ही उसका इस्तेमाल विज्ञापन के लिए करते हैं।'],
    },
    {
      id: 'security',
      heading: 'हम इसकी सुरक्षा कैसे करते हैं',
      blocks: [
        'डेटा भेजते समय (in transit) और स्टोर रहते समय (at rest) एन्क्रिप्टेड रहता है। ZenQuip के अंदर इसकी पहुँच सिर्फ़ उन लोगों तक सीमित है जिन्हें अपने काम के लिए इसकी ज़रूरत है। रिपोर्ट के PDF निजी होते हैं और सिर्फ़ ऐसे लिंक से खुलते हैं जिनकी समय-सीमा कुछ ही मिनटों में ख़त्म हो जाती है; आपके बनाए शेयर लिंक आपकी चुनी हुई तारीख़ पर ख़त्म हो जाते हैं।',
        'अगर कभी किसी डेटा ब्रीच (सुरक्षा उल्लंघन) का असर आपके डेटा पर पड़ता है, तो हम क़ानून के अनुसार आपको और भारतीय डेटा संरक्षण बोर्ड (Data Protection Board of India) को इसकी सूचना देंगे।',
      ],
    },
    {
      id: 'retention',
      heading: 'हम इसे कितने समय तक रखते हैं',
      blocks: [
        'रिपोर्ट, जवाब और घर के रिकॉर्ड आपकी आख़िरी गतिविधि के बाद 24 महीने तक रखे जाते हैं, जब तक कि आप उन्हें पहले न हटा दें। जब आप सेटिंग्स में अपने बच्चों का डेटा या अपना अकाउंट हटाते हैं, तो वह ऐप से तुरंत हट जाता है; हमारे बैकअप में मौजूद कोई भी कॉपी 35 दिन के भीतर ख़त्म हो जाती है।',
        'इनवॉइस और भुगतान के रिकॉर्ड उतने समय तक रखे जाते हैं जितना भारतीय टैक्स क़ानून के तहत ज़रूरी है, और उनमें व्यक्तिगत जानकारी कम से कम रखी जाती है। सुरक्षा लॉग क़ानून के अनुसार रखे जाते हैं।',
      ],
    },
    {
      id: 'your-rights',
      heading: 'आपके अधिकार',
      blocks: [
        'DPDP Act के तहत आप:',
        [
          'हमारे पास मौजूद डेटा और उसके इस्तेमाल का सारांश **देख** सकते हैं, सेटिंग्स → मेरा डेटा डाउनलोड करें;',
          'कोई भी ग़लत जानकारी **सुधार** सकते हैं, ऐप में बदलें, या हमसे कहें;',
          'अपने बच्चों का डेटा या अपना पूरा अकाउंट **हटा** सकते हैं, सेटिंग्स में, एक क़दम में;',
          'कभी भी **सहमति वापस ले** सकते हैं;',
          'किसी व्यक्ति को **नामित (नॉमिनेट)** कर सकते हैं, जो आपकी मृत्यु होने पर या आपके कार्य करने में असमर्थ होने पर आपकी ओर से इन अधिकारों का इस्तेमाल करे, सेटिंग्स → निजता;',
          'हमारे शिकायत अधिकारी से **शिकायत** कर सकते हैं, और फिर, अगर आप संतुष्ट न हों, तो भारतीय डेटा संरक्षण बोर्ड (Data Protection Board of India) से।',
        ],
        'साइन इन नहीं हो पा रहा? [डेटा हटाने का अनुरोध](/data-request) इस्तेमाल करें। कोई कार्रवाई करने से पहले हम पुष्टि करेंगे कि यह आप ही हैं, आमतौर पर आपके रजिस्टर्ड नंबर पर एक वन-टाइम कोड भेजकर।',
      ],
    },
    {
      id: 'grievance-officer',
      heading: 'शिकायत अधिकारी',
      blocks: [
        'ऊपर दिए गए किसी भी अधिकार का इस्तेमाल करने, या निजता से जुड़ी कोई चिंता उठाने के लिए, हमारे शिकायत अधिकारी (Grievance Officer) से संपर्क करें:',
        [
          `**${GRIEVANCE_OFFICER.name}**, ${COMPANY.legalName}`,
          COMPANY.address,
          `ईमेल: [${GRIEVANCE_OFFICER.email}](mailto:${GRIEVANCE_OFFICER.email})`,
          `फ़ोन: [${GRIEVANCE_OFFICER.phone}](${GRIEVANCE_OFFICER.phoneHref})`,
        ],
        `हम ${GRIEVANCE_OFFICER.resolveDays} दिन के भीतर जवाब देते हैं।`,
      ],
    },
    {
      id: 'cookies',
      heading: 'आपके डिवाइस पर कुकीज़ और स्टोरेज',
      blocks: [
        '**ऐप के लिए ज़रूरी:** आपका साइन-इन, आपकी भाषा और कुकीज़ के बारे में आपकी पसंद। ये हमेशा चालू रहती हैं।',
        '**एनालिटिक्स, सिर्फ़ तभी जब आप “एनालिटिक्स की अनुमति दें” चुनें:** हम Google Analytics (Google LLC) और PostHog (PostHog Inc., EU में सर्वर) का इस्तेमाल कर सकते हैं। ये हमारे सार्वजनिक पेजों (होम, FAQ, Learn, Trust, क़ानूनी पेज और साइन-इन) पर चलते हैं, घरेलू आकलन, रिपोर्ट, घरेलू प्रोग्राम या आपके बच्चे से जुड़ी किसी भी चीज़ पर कभी नहीं। ये आपके डिवाइस पर एक पहचानकर्ता (identifier) रखते हैं (“_ga” नाम की कुकीज़ और “ph_…” नाम का ब्राउज़र स्टोरेज) और पेज का पता, आपका ब्राउज़र और डिवाइस का प्रकार, अनुमानित लोकेशन और वह साइट जहाँ से आप आए, प्राप्त करते हैं, ताकि हम विज़िट गिन सकें। विज्ञापन फ़ीचर, Google signals और सेशन रिकॉर्डिंग बंद हैं। यह डेटा 12 महीने से ज़्यादा नहीं रखा जाता (Google Analytics: 2 महीने) और भारत के बाहर प्रोसेस किया जाता है।',
        'आप हर पेज के नीचे “कुकी सेटिंग्स” से कभी भी अपनी पसंद बदल सकते हैं। मना करने से ऐप में और कुछ नहीं बदलता। हम विज्ञापन वाली कुकीज़ का इस्तेमाल नहीं करते।',
      ],
    },
    {
      id: 'where-stored',
      heading: 'आपका डेटा कहाँ स्टोर होता है',
      blocks: [
        'भारत में (Amazon Web Services, मुंबई), भारत और दूसरे देशों के परिवारों, दोनों के लिए। एकमात्र अपवाद एनालिटिक्स डेटा है, अगर आप उसकी अनुमति दें (देखें “कुकीज़”), जिसे Google और PostHog भारत के बाहर प्रोसेस करते हैं। अगर इसके अलावा कुछ भी बदलता है, तो हम पहले यह नीति अपडेट करेंगे और डेटा ट्रांसफ़र के बारे में DPDP Act के नियमों का पालन करेंगे।',
      ],
    },
    {
      id: 'changes',
      heading: 'इस नीति में बदलाव',
      blocks: [
        'हम बदलाव यहाँ पोस्ट करेंगे और ऊपर दी गई तारीख़ बदल देंगे। अगर किसी बदलाव से उस डेटा के इस्तेमाल पर असर पड़ता है जो आप हमें पहले ही दे चुके हैं, तो उसके लागू होने से पहले हम आपको ऐप में या संदेश से बताएँगे।',
      ],
    },
    {
      id: 'contact',
      heading: 'संपर्क',
      blocks: [
        `Nurture के बारे में सवाल: [${COMPANY.supportEmail}](mailto:${COMPANY.supportEmail})। निजता से जुड़े अनुरोध और शिकायतें: [${GRIEVANCE_OFFICER.email}](mailto:${GRIEVANCE_OFFICER.email})।`,
      ],
    },
  ],
};
